import React from 'react'
import { IntlProvider } from 'react-intl'
import { FormValidationLangProvider } from './formValidator.context'
import { ThemeProvider } from './theme.context'
import { FlagsProvider } from './feature-flags-provider.context'

import { localeMessages } from '../locale'
import settings, { APP_FEATURES } from '../settings'
import { Helmet } from 'react-helmet'

const { appTitle, LOCALE_IN_USE } = settings

const AppProvider = ({ children }) => (
  <FlagsProvider features={APP_FEATURES}>
    <Helmet>
      <title>{appTitle}</title>
    </Helmet>
    <IntlProvider locale={LOCALE_IN_USE} messages={localeMessages}>
      <ThemeProvider>
        <FormValidationLangProvider>{children}</FormValidationLangProvider>
      </ThemeProvider>
    </IntlProvider>
  </FlagsProvider>
)

export default AppProvider
